@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (box3Beleggingen.length > 0) {
      <div formArrayName="box3Beleggingen">
        @for (item of box3Beleggingen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Naam belegging' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Rekeningnummer' : ''"
                                              class="custom-input-200"
                                              formControlName="rekeningNummer"
                                              id="rekeningNummer"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Land' : ''"
                                                [options]="optionsLandcodes"
                                                [required]="true"
                                                class="custom-input-150"
                                                formControlName="landCode"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? labelJaar : ''"
                                                [minValue]="0"
                                                [required]="true"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                id="bedrag"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Groene belegging' : ''"
                                                [options]="optionsJaNee"
                                                [required]="true"
                                                class="custom-input-150"
                                                formControlName="groenRekening"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-button (click)="showDialog(i)"
                                   [disabled]="!heeftOWR"
                                   [class]="i === 0 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                                   [icon]="'plus'"
                                   type="secondary">
                OWR
              </snelstart-ui-button>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>

              @if ((incomeTaxEntity$ | async)?.aangifte?.box3?.berekenWerkelijkRendement && item.get('bedrag')?.value == 0) {
                <snelstart-ui-alert type="danger">
                  Let op! Een belegging met een saldo EUR 0 levert problemen op bij het indienen van de aangifte.
                  Verwijder daarom deze regel!
                </snelstart-ui-alert>
              }
            </div>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" type="link">
    Belegging toevoegen
  </snelstart-ui-button>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                  [title]="getOWRDialogTitel(index)"
                                  id="owrBeleggingen"
                                  size="lg">
    <snelstart-ui-dialog-body>
      <form [formGroup]="formGroup">
        @if (box3Beleggingen.length > 0) {
          <div formArrayName="box3Beleggingen">
            @for (item of box3Beleggingen.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if (i === index) {
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [label]="labelJaarEind"
                                                    [minValue]="0"
                                                    [required]="true"
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="waardeEindJaar"
                                                    id="bedrag"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [label]="labelJaar"
                                                    [minValue]="0"
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="bedrag"
                                                    id="bedrag"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [minValue]="0"
                                                    [required]="true"
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="stortingen"
                                                    id="bedrag"
                                                    label="Aankopen/stortingen"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [minValue]="0"
                                                    [required]="true"
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="onttrekkingen"
                                                    id="bedrag"
                                                    label="Verkopen/onttrekkingen"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [required]="true"
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="directRendement"
                                                    id="bedrag"
                                                    label="Bruto dividend/rente"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [required]="true"
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="valutaResultaat"
                                                    id="bedrag"
                                                    label="Valuta koerswinst-/verlies"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <div class="pt-2">
                    <div class="d-flex align-items-center">
                      <div class="result-inline">
                        @let rendement = getBerekendeWerkelijkRendement(i);
                        Werkelijk rendement in {{ jaar }} =
                        EUR {{ rendement != null ? (rendement | number:'1.0-2') : '0' }}
                      </div>
                    </div>
                    <br/><br/>
                    {{ getGroen(i) }}
                  </div>
                  <div class="space20"></div>

                  @if (box3Beleggingen.controls[i].get('groenRekening')?.value === true) {
                    <snelstart-ui-alert type="warning">
                      Let op! Als er in de loop van {{ jaar }} een groene belegging (effecten of spaartegoed)
                      is gekocht of verkregen, hoeft het werkelijke rendement hierover nog niet opgenomen
                      te worden in de aangifte over {{ jaar }}.
                    </snelstart-ui-alert>
                  }
                }
              </div>
            }
          </div>
        }
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
      </snelstart-ui-button>
      <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
